import { atomWithStorage, createJSONStorage } from "jotai/utils";

const storage = createJSONStorage(() => sessionStorage);

export const atomPersistor = <Value>(key: string, defaultValue: Value) => atomWithStorage(key, defaultValue, storage);
